import { render, staticRenderFns } from "./StatisticsAccessByLanguages.vue?vue&type=template&id=96d45798&"
import script from "./StatisticsAccessByLanguages.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports